import {ampli} from '../ampli/index';
import useCustomConfig from "~/composables/useEnvConfig";

export default defineNuxtPlugin(() => {
    const config = useCustomConfig();
    ampli.load({client: {apiKey: config.public.AMPLI_KEY}});
})